module.exports = __webpack_public_path__ + "orgIcon-f4206cc50c87f8f87f114f74d942943e.png";